import { flow, getRoot, Instance, types } from 'mobx-state-tree';

import spotifyService from '../../services/spotifyService';
import { IRootStore } from '../RootStore';
import TrackModel from './TrackModel';

const PlaylistModel = types
    .model('PlaylistModel', {
        id: types.identifier,
        name: types.string,
        imageUrl: types.optional(types.string, ''),
        uri: types.string,
        tracks: types.optional(types.map(types.reference(TrackModel)), {}),
    })
    .actions(self => {
        const getTracks = flow(function*() {
            const rootStore: IRootStore = getRoot(self);
            try {
                if (self.tracks.size) {
                    return;
                }
                const response: SpotifyApi.PlaylistTrackResponse = yield spotifyService.getPlaylistTracks(self.id);
                response.items.forEach(track => {
                    self.tracks.set(track.track.id, rootStore.music.addTrack(track.track));
                });
            } catch (error) {
                console.log(error);
                if (error.status === 401) {
                    rootStore.auth.signOut();
                }
            }
        });
        return { getTracks };
    });

export interface IPlaylistModel extends Instance<typeof PlaylistModel> {}

export default PlaylistModel;
